import { FormizoSchema } from "Components/LabIZO/Formizo/FormizoSchema.interface";

export const SpamSetting: FormizoSchema[] = [
  {
    header: "Human SPAM Setting",
  },
  {
    label: "Block Time (sec)",
    name: "SettingDoc.HumanSpam.BlockDuration",
    variant: "outlined",
    format: "number",
  },
  {
    label: "Attempt Threshold",
    name: "SettingDoc.HitRate.HumanMaxStamp",
    variant: "outlined",
    format: "number",
  },
  {
    header: "BOT SPAM Setting",
  },
  {
    label: "Block Time (sec)",
    name: "SettingDoc.BotSpam.BlockDuration",
    variant: "outlined",
    format: "number",
  },
  {
    label: "Time interval (sec)",
    name: "SettingDoc.BotSpam.TimeInterval",
    variant: "outlined",
    format: "number",
  },
  {
    label: "Attempt Threshold",
    name: "SettingDoc.HitRate.BotMaxStamp",
    variant: "outlined",
    format: "number",
  },
  {
    header: "IP SPAM Setting",
  },
  {
    label: "Block Time (sec)",
    name: "SettingDoc.IpSpam.BlockDuration",
    variant: "outlined",
    format: "number",
  },
  {
    label: "Time interval (sec)",
    name: "SettingDoc.IpSpam.TimeInterval",
    variant: "outlined",
    format: "number",
  },
  {
    label: "Attempt Threshold",
    name: "SettingDoc.HitRate.IpMaxStamp",
    variant: "outlined",
    format: "number",
  },
  {
    header: "Human SPAM Message",
  },
  {
    label: "EN",
    name: "SettingDoc.Message.HumanSpam.EN",
    variant: "outlined",
    format: "text",
  },
  {
    label: "TC",
    name: "SettingDoc.Message.HumanSpam.TC",
    variant: "outlined",
    format: "text",
  },
  {
    label: "SC",
    name: "SettingDoc.Message.HumanSpam.SC",
    variant: "outlined",
    format: "text",
  },
  {
    header: "Bot SPAM Message",
  },
  {
    label: "EN",
    name: "SettingDoc.Message.BotSpam.EN",
    variant: "outlined",
    format: "text",
  },
  {
    label: "TC",
    name: "SettingDoc.Message.BotSpam.TC",
    variant: "outlined",
    format: "text",
  },
  {
    label: "SC",
    name: "SettingDoc.Message.BotSpam.SC",
    variant: "outlined",
    format: "text",
  },
  {
    header: "IP SPAM Message",
  },
  {
    label: "EN",
    name: "SettingDoc.Message.IpSpam.EN",
    variant: "outlined",
    format: "text",
  },
  {
    label: "TC",
    name: "SettingDoc.Message.IpSpam.TC",
    variant: "outlined",
    format: "text",
  },
  {
    label: "SC",
    name: "SettingDoc.Message.IpSpam.SC",
    variant: "outlined",
    format: "text",
  },
];
